'use client';

import React from 'react';
import Navbar from './Navbar';

interface NavbarWrapperProps {
  showNewsAlert?: boolean;
  setShowNewsAlert?: (show: boolean) => void;
}

const NavbarWrapper = ({ showNewsAlert, setShowNewsAlert }: NavbarWrapperProps) => {
  return <Navbar showNewsAlert={showNewsAlert} setShowNewsAlert={setShowNewsAlert} />;
};

export default NavbarWrapper; 